import styled, { css } from 'styled-components'

import { CheckBoxFormField, SelectFormField } from '@/components/UberForm'

export const Column = styled.div`
	display: flex;
	padding: 10px 5px 0 0;
`

export const Name = styled.div`
	flex: 1;
	margin-left: 10px;
`

export const Action = styled.div<{ $isHidden?: boolean }>`
	margin: 0 5px;
	cursor: pointer;
	display: flex;
	align-items: center;

	${(props) => css`
		visibility: ${props.$isHidden ? 'hidden' : 'initial'};
	`}
`

export const SelectField = styled(SelectFormField)`
	width: 100%;
	border: 0;
	margin-bottom: 1px;
	border-right: 1px solid #ddd;

	.react-select__control {
		border: 0;
	}
` as unknown as new <T>() => SelectFormField<T>

export const CheckBoxField = styled(CheckBoxFormField)`
	margin: 0 10px 0 14px;
	flex: 0 1 auto;
	& label {
		height: auto;
		padding: 0 0 0 16px;
	}
`
